module.exports = __webpack_public_path__ + "static/media/featuresection2.adb6a856.png";